import { render, staticRenderFns } from "./GenerateOnboardVaccinatedCrew.vue?vue&type=template&id=08a1ec84&scoped=true&"
import script from "./GenerateOnboardVaccinatedCrew.vue?vue&type=script&lang=js&"
export * from "./GenerateOnboardVaccinatedCrew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08a1ec84",
  null
  
)

export default component.exports